import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import type { McReviewFormValues } from 'src/interfaces/documentReview'
import { McReviewFormContent } from './McReviewFormContent'

interface Props {
  /** The decision bar and context cards, rendered inside the form so they can read its values. */
  children: ReactNode
}

const INITIAL_VALUES: McReviewFormValues = {
  documentId: '',
  dateIssued: '',
  expiresAt: '',
}

/**
 * Unlike the contractor form, the MC expiration requirement has no exemptions at all — see
 * `resolveMcApproveBlockReason` — so the schema requires it unconditionally rather than taking a
 * discriminant.
 */
const validationSchema = Yup.object({
  documentId: Yup.string(),
  dateIssued: Yup.string(),
  expiresAt: Yup.string().required('Expiration date is required.'),
})

const McReviewFormComponent = ({ children }: Props) => {
  return (
    <Formik<McReviewFormValues>
      initialValues={INITIAL_VALUES}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={() => {
        // Submission runs through the Approve / Reject modals, not a form submit — the two
        // actions send different bodies to different endpoints.
      }}
    >
      {/* The form and its decision bar sit in one white card, like the cards beside them. */}
      <Form
        css={tw`flex shrink-0 flex-col gap-4 rounded-lg border border-solid border-shades-100 bg-shades-0 p-6`}
      >
        <McReviewFormContent />
        {children}
      </Form>
    </Formik>
  )
}

export const McReviewForm = memo(McReviewFormComponent)
